<template>
  <div class="topTopBox" id="topBox" v-if="isLoaded">
    <div class="flex_csb topFixed" :style="isBack ? 'box-shadow:0 5px 5px 1px rgba(0,0,0,0.1)' : 'box-shadow:none'"
         v-show="!isClose">
      <div class="flex_c leftLogo" @click.stop="goPages(menu[0], 0,null,null,$event)"
           v-if="config && config.backendLogo">
<!--        <img src="http://japanjukiadmin.jukicc.com/upload/2025/03/26/303980453_20250326181900a020.png" alt="logo" class="img">-->
        <img :src="config.logo" alt="logo" class="logo">
        <!-- <div :style="screenWidth >= 1200 ? 'margin-left: 18px;' : 'margin-left: 10px;'" class="logoTitle ellipsis" v-if="config && config.corporateName">{{ language == 'zh' ? config.corporateName : config.enCorporateName}}</div> -->
      </div>
      <div class="menuBox" v-if="screenWidth >= 1200">
        <div class="color_f menuTitle fontSize14" v-for="item, index in menu" :key="index"
             @click.stop="goPages(item, index,null,null,$event)" v-show="item.isHidden == 0">
          <el-popover class="elPopover" placement="bottom fontSize14" width="150" trigger="hover"
                      v-if="item.childList && item.childList.length > 0">
            <div class="menuTwo fontSize14">
              <div class="menuTwoTitle fontSize14" v-for="(item1, index1) in item.childList" :key="index1"
                   @click.prevent="goPages(item1, index, item1.id,null,$event)"
                   :style="indexOf == item.id && $store.state.twoIndex == item1.id ? 'color:#ff0000;font-weight:bold;' : ''">
                {{ language == 'zh' ? item1.typename : item1.enTypename }}
              </div>
            </div>
            <div slot="reference"
                 class="fontSize14"
                 :style="indexOf == item.id ? 'color:#ff0000;font-weight:bold;' : 'color:#000000;font-weight:400;'">
              {{ language == 'zh' ? item.typename : item.enTypename }}
            </div>
          </el-popover>
          <el-popover placement="bottom fontSize14" width="150" trigger="hover"
                      v-else-if="item.categoryList && item.categoryList.length > 0">
            <div class="menuTwo elPopoverSe fontSize14">
              <div class="menuTwoTitle fontSize14" v-for="(item1, index1) in item.categoryList" :key="index1"
                   @click.prevent="goPages(item1, index, item1.id, 'list',$event)"
                   :style="indexOf == item.id && $store.state.twoIndex == item1.id ? 'color:#ff0000;font-weight:bold;' : ''">
                {{ language == 'zh' ? item1.title : item1.enTitle }}
              </div>
            </div>
            <div slot="reference"
                 class="fontSize14"
                 :style="indexOf == item.id ? 'color:#ff0000;font-weight:bold;' : 'color:#000000;font-weight:400;'">
              {{ language == 'zh' ? item.typename : item.enTypename }}
            </div>
          </el-popover>
          <div v-else
               class="fontSize14"
               :style="indexOf == item.id ? 'color:#ff0000;font-weight:bold;' : 'color:#000000;font-weight:400;'"
               @click.stop="goPages(item, index,null,null,$event)">
            {{ language == 'zh' ? item.typename : item.enTypename }}
          </div>
        </div>
        <span class="fontSize14" @click="changeLange" style="cursor: pointer;margin-left: 28px;">{{
            language == 'en' ?
                'En/ 中文' : '中文 / En'
          }}</span>
      </div>
      <div class="menuPhone" v-if="screenWidth < 1200">
        <!--                <span class="" @click="changeLange" style="cursor: pointer;margin-right: 10px;">{{-->
        <!--        language-->
        <!--            == 'en' ? 'En / 中文'-->
        <!--            :-->
        <!--            '中文 / En' }}</span>-->
        <img src="@/assets/img/menu.png" alt="菜单" class="menu" @click="isCloseChange">
      </div>
    </div>
    <div class="swiperBox animate__animated animate__slow animate__fadeInDown" v-if="indexOf == 0"
         style="width: 100%;">
      <Swiper :options="swiperOption" ref="mySwipers">
        <SwiperSlide v-for="(item, index) in bannerLists" :key="index">
          <div style="cursor:pointer">
            <img v-if="screenWidth >= 1200" :src="language == 'zh' ? item.url : item.enUrl" alt=""
                 style="width:100%;display: block;object-fit: cover;margin:0 auto;"
                 :data-v="JSON.stringify(item)">
            <img v-if="screenWidth < 1200" :src="item.mobileUrl" alt=""
                 style="width:100%;display: block;object-fit: cover;margin:0 auto;"
                 :data-v="JSON.stringify(item)">
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
    <div v-if="indexOf != 0  && screenWidth >= 1200">
      <img id="banner" :src="banner" alt="" style="width: 100%;display: block;"
           class=" animate__animated animate__slow" v-appear="'animate__fadeInDown'" v-if="isLoaded">
    </div>
    <div v-if="indexOf != 0 && screenWidth < 1200">
      <img id="banner" :src="mobileBanner" alt="" style="width: 100%;display: block;"
           class=" animate__animated animate__slow" v-appear="'animate__fadeInDown'" v-if="isLoaded">
    </div>
    <!-- 弹出层：菜单 -->
    <div class="mask" v-show="isClose">
      <div class="flex_csb">
        <img src="http://japanjukiadmin.jukicc.com/upload/2025/03/26/303980453_20250326181900a020.png" alt="logo" class="logo">
        <img src="../assets/imgs/close.png" alt="close" class="menu" @click="isCloseChange">
      </div>
      <div class="titleBox">
        <el-menu default-active="2" class="el-menu-vertical-demo" background-color="#333333" text-color="ffffff"
                 active-text-color="#ffd04b">
          <div v-for="item, index in menu" class="marginTop5" :key="index" :index="index">
            <el-submenu :index="`a-${index}`" v-if="item.childList && item.childList.length > 0">
              <template slot="title">
                                <span slot="title" :style="indexOf == item.id ? 'color:#ff0000;font-weight:bold;width: 100% !important;display: block;' : 'color:#FFFFFF;font-weight:400;width: 100% !important;display: block;'">
                                  {{language == 'zh' ? item.typename : item.enTypename }}
                                </span>
              </template>
              <el-menu-item v-for="(item1, index1) in item.childList" :key="index1"
                            :index="`${index}-${index1}`">
                                <span slot="title" @click.prevent="goPages(item1, index, item1.id,null,$event)"
                                      :style="twoIndex == item1.id ? 'color: #ff0000;font-weight:bold;width: 100% !important;display: block;' : 'color:#ffffff;font-weight:400;width: 100% !important;display: block;'">{{
                                    language == 'zh' ?
                                        item1.typename :
                                        item1.enTypename
                                  }}</span>
              </el-menu-item>
            </el-submenu>
            <el-submenu :index="`a-${index}`" v-else-if="item.categoryList && item.categoryList.length > 0">
              <template slot="title">
                                <span slot="title"
                                      :style="indexOf == item.id ? 'color: #ff0000;font-weight:bold;width: 100% !important;display: block;' : 'color:#ffffff;font-weight:400;width: 100% !important;display: block;'">{{
                                    language == 'zh' ? item.typename :
                                        item.enTypename
                                  }}</span>
              </template>
              <el-menu-item v-for="(item1, index1) in item.categoryList" :key="index1"
                            :index="`${index}-${item1.id}`">
                                <span slot="title"
                                      :style="twoIndex == item1.id ? 'color: #ff0000;font-weight:bold;width: 100% !important;display: block;' : 'color:#ffffff;font-weight:400;width: 100% !important;display: block;'"
                                      @click.prevent="goPages(item1, index, item1.id, 'list',$event)">{{
                                    language == 'zh' ?
                                        item1.title :
                                        item1.enTitle
                                  }}</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item :index="`a-${index}`" v-else>
                            <span slot="title"
                                  :style="indexOf == item.id ? 'color:#ff0000;font-weight:bold;width: 100% !important;display: block;' : 'color:#FFFFFF;font-weight:400;width: 100% !important;display: block;'"
                                  @click.stop="goPages(item, index,null,null,$event)">{{
                                language == 'zh' ? item.typename :
                                    item.enTypename
                              }}</span>
            </el-menu-item>
          </div>
          <div class="marginTop5" @click="changeLange" style="color: #ffffff;cursor: pointer;margin-right: 10px;">

            <li data-v-785ffe81="" role="menuitem" tabindex="-1" class="el-menu-item"
                style="padding-left: 20px; background-color: rgb(51, 51, 51);">
                      <span data-v-785ffe81=""
                            style="color: rgb(255, 255, 255); font-weight: 400; width: 100% !important; display: block;">
                    {{ language == 'en' ? 'En / 中文' : '中文 / En' }}
                      </span>
            </li>
          </div>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  props: {
    screenWidth: {
      typeof: Number,
      default: 0
    },
    language: {
      typeof: String,
      default: 'zh'
    },
    title: {
      typeof: String,
      default: ''
    },
    title1: {
      typeof: String,
      default: ''
    },
    isLogo: {
      typeof: Boolean,
      default: true,//true白色logo标 false绿色logo标识
    },
    menu: { //菜单
      typeof: Array,
      default: () => []
    },
    screenHeight: {
      typeof: Number,
      default: 0,
    },
    bannerLists: { //菜单
      typeof: Array,
      default: () => []
    },
    isLoop: {
      typeof: Boolean,
      default: true
    },
    config: {
      typeof: Object,
      default: {}
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      isLoaded: false,
      isShow: true,
      height: 0,
      isClose: false,
      indexOf: null, //一级菜单选中id
      twoIndex: null,//二级菜单选中id
      banner: '',//一级菜单banner
      mobileBanner: '',//一级菜单手机端banner
      infoId: null,//详情id
      typeId: null,//跳转详情时的栏目id
      categoryId: null,//跳转详情的分类id
      swiperOption: {
        //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        //notNextTick: true,
        //循环
        loop: this.isLoop,
        //自动播放
        slidesPerView: "auto",
        autoplay: {
          delay: 3000,
          // stopOnLastSlide: false,//如果设置为true，当切换到最后一个slide时停止自动切换。（loop模式下无效）。
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        //滑动速度
        speed: 3000,
        //滑动方向
        direction: 'horizontal',
        //小手掌抓取滑动
        grabCursor: true,
        // pagination: {
        //     el: ".swiper-pagination",
        //     type: 'custom',//  圆点（默认） fraction’  分式 ‘progressbar’  进度条 custom’ 自定义
        //     clickable: true,//点击分页器的指示点分页器会控制Swiper切换
        // },
        on: {
          click: (event) => {
            if (event.target.getAttribute('data-v')) {
              // 这里的 obj 就是当前点击图片所对应的信息
              let obj = JSON.parse(event.target.getAttribute('data-v'))
              if (!obj.path || obj.path == '') return
              let path = JSON.parse(obj.path)
              let index = this.menu.findIndex(item => item.id == path.menuId)
              if (index != -1) this.goPages(this.menu[index], index)
              // this.goPages(item, index)
            }
          },
        }
      },
      savedSwiper: null,
      bannerObj: null,
      isBack: false,
      num: 0,
    }
  },
  watch: {
    "$store.state.jumpPath": {
      handler: function (newVal) {
        console.log("newVal", newVal)
        if (newVal == 1) { //分类
          let categoryId = JSON.parse(localStorage.getItem('categoryId'))
          if (!categoryId) return
          this.goPages(this.menu[1], 1, categoryId, 'lists')
        }
        if (newVal == 2) { //分类中心
          this.goPages(this.menu[1], 1)
        }
        if (newVal == 3) { //跳转分类详情
          let data = JSON.parse(localStorage.getItem('info'))
          if (!data) return
          localStorage.setItem('isList', 1)
          this.infoId = data.id
          this.typeId = data.typeId
          this.categoryId = data.categoryId
          this.goPages(this.menu[1], 1, '', 'info')
        }
        if (newVal == 5) { //跳转新闻列表
          this.goPages(this.menu[3], 3)
        }
        if (newVal == 6) { //跳转新闻详情
          let news = JSON.parse(localStorage.getItem('news'))
          if (!news) return
          this.goPages(this.menu[3], 3, news.id)
        }
        if (newVal == 7) { //跳转关于我们
          this.goPages(this.menu[4], 3)
        }
        this.$store.commit('changeJump')
      }
    },
    // "screenWidth": {
    // handler: function (newVal) {
    // }
    // },

    language(newVal) {
      let path = this.$route.path
      if (path == '/') return
      this.banner = ''
      // let topBox = document.getElementById('topBox');
      if (!this.bannerObj) {
        this.bannerObj = JSON.parse(localStorage.getItem('bannerObj'))
      }
      this.banner = newVal == 'zh' ? this.bannerObj.banner : this.bannerObj.enBanner
    },
    banner(newVal) {
      let node = document.getElementById('banner');
      if (node) {
        let isHave = node.classList.contains('animate__fadeInDown');
        if (isHave) {
          document.getElementById("banner").classList.remove("animate__fadeInDown");
        }//移除banner类名

        document.getElementById("banner").classList.add("animate__fadeInDown");
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwipers.$swiper;
    },
  },
  methods: {
    change(index) {
      return index
    },
    // getHeight() {
    //     this.height = this.$refs.swiperBox.offsetHeight
    // },
    handleScroll() {
      const scrollTop = window.scrollY;
      this.isBack = scrollTop > 100 ? true : false
    },
    changeLange() {
      this.$emit('changeLange')
    },
    isCloseChange() {
      this.isClose = !this.isClose
    },
    goPages(data, index, twoId, isCategory, event) { //选中
      console.log("event", event)
      if (event) {
        event.stopPropagation()
      }

      let a = document.getElementsByClassName("el-popper");
      for (let i = 0; i < a.length; i++) {
        a[i].style.display = "none"
      }
      console.log("data", data)
      // console.log("this",this)
      // console.log("this.$refs[`pop-` + id]",this.$refs[`pop-` + data.id])
      // this.$refs[`pop-` + data.id].doclose
      // window.location.reload()
      // this.$router.go(0)
      let node = document.getElementById('banner');
      if (node) {
        let isHave = node.classList.contains('animate__fadeInDown');
        if (isHave) {
          document.getElementById("banner").classList.remove("animate__fadeInDown");
        }//移除banner类名
      }
      if (data.id == 139) {
        index = 0
        twoId = data.id
        data = this.menu[index]
      }
      if (data.columnType == 0) {
        // topBox.style.backgroundImage = ``;
      } else {
        this.banner = this.language == 'zh' ? this.menu[index].banner : this.menu[index].enBanner
        this.mobileBanner = this.language == 'zh' ? this.menu[index].mobileBanner : this.menu[index].mobileBanner
        this.bannerObj = {
          banner: this.menu[index].banner,
          enBanner: this.menu[index].enBanner
        }
        localStorage.setItem('bannerObj', JSON.stringify(this.bannerObj)) //缓存banner
      }
      localStorage.setItem('banner', this.banner) //缓存
      localStorage.setItem('mobileBanner', this.mobileBanner) //缓存
      this.indexOf = this.menu[index].id
      this.twoIndex = twoId ? twoId : -1
      localStorage.setItem('getTwoMenu', JSON.stringify(this.menu[index].childList)) //缓存二级菜单
      localStorage.setItem('choiceOne', this.indexOf) //缓存当前选择1级菜单的index
      localStorage.setItem('choiceTwo', this.twoIndex) //缓存当前选择2级菜单的index
      this.$store.commit('changeOneIndex', this.indexOf)
      this.$store.commit('changeTwoIndex', this.twoIndex)
      // 产品二级点击
      if (isCategory) {
        if (isCategory == 'info') {
          this.$router.push({
            name: 'productInfo',
            query: {columnId: this.typeId, columnType: 2, categoryId: this.categoryId, infoId: this.infoId}
          })
        }
        if (isCategory == 'list') {
          this.$router.push({name: 'productIndex', query: {columnId: data.typeId, columnType: 2, categoryId: data.id}})
        }
        if (isCategory == 'cowList') {
          this.$router.push({
            name: 'productIndex',
            query: {columnId: data.id, columnType: 2, categoryId: data.categoryId}
          })
        }
        if (isCategory == 'lists') {
          this.$router.push({
            name: 'productIndex',
            query: {columnId: data.id, columnType: data.columnType, categoryId: twoId}
          })
        }
      } else if ((data.columnType > 6 || data.columnType < -1) && this.menu[index].childList && this.menu[index].childList.length > 0) {// 0首页 1 3 video视频中心 2productCenter 4暂定video视频中心 5 message留言 6 oration单页 如果有子菜单mine
        this.$router.push({name: 'mine', query: {columnId: data.id, columnType: data.columnType}})
      } else if (data.columnType == -1) {
        this.$router.push({name: 'cowboyOnly'})
      } else if (data.columnType == 0) {
        if (twoId) {
          this.$router.push({path: '/', query: {type: ++this.num}})
        } else {
          this.$router.push({path: '/'})
        }

      } else if (data.columnType == 1) {
        let nowMenu;
        let a = this.menu.find(item => item.id == data.parentId)
        if (a) {
          nowMenu = a.childList.find(item => item.id == data.id);
        }
        if (twoId && nowMenu) {
          this.$router.push({
            name: 'news',
            query: {columnId: data.id, columnIdTwo: data.parentId, columnType: data.columnType, id: twoId}
          })
        }
        if (twoId && !nowMenu) {
          this.$router.push({
            name: 'newsInfo',
            query: {columnId: data.id, columnIdTwo: data.parentId, columnType: data.columnType, id: twoId}
          })
        } else {
          console.log("data.columnType == 1", data)
          this.$router.push({
            name: 'news',
            query: {columnId: data.parentId != 0 ? data.parentId : data.id, columnIdTwo: data.parentId != 0 ? data.id : 0, columnType: data.columnType}
          })
        }
      } else if (data.columnType == 2) {
        this.$router.push({name: 'productIndex', query: {columnId: data.id, columnType: data.columnType}})
      } else if (data.columnType == 3) {
        this.$router.push({name: 'video', query: {columnId: data.id, columnType: data.columnType}})
      } else if (data.columnType == 4) {
        this.$router.push({name: 'video', query: {columnId: data.id, columnType: data.columnType}})
      } else if (data.columnType == 5) {
        this.$router.push({name: 'message', query: {columnId: data.id, columnType: data.columnType}})
      } else if (data.columnType == 6) {
        if (data.id == 132) {
          this.$router.push({name: 'cowboyOnly', query: {columnId: data.id, columnType: data.columnType}})
        } else {
          console.log("gopage 6 oration")
          console.log("data", data.id, data.parentId, data.columnType)
          if(data.id == 137){
            this.$router.push({
              name: 'news',
              query: {columnId: data.parentId != 0 ? data.parentId : data.id, columnIdTwo: data.parentId != 0 ? data.id : 0, columnType: data.columnType}
            })
          }else {
            this.$router.push({
              name: 'oration',
              query: {columnId: data.id, columnIdTwo: data.parentId, columnType: data.columnType}
            })
          }

        }
      } else {
        this.$router.push({name: 'oration', query: {columnId: data.id, columnType: data.columnType}})
      }
      if (this.isClose) this.isClose = false
    },
  },
  created() {
    this.banner = localStorage.getItem('banner')
    this.indexOf = this.$store.state.oneIndex || 0
    this.twoIndex = this.$store.state.twoIndex || -1
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.isLoaded = true
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<style scoped lang="scss">
$height: 80px;
$min-height: 60px;
.elPopoverSe {
  //transform: translateX(-50%);
  //left:25%;
}

::v-deep .el-popover {
  padding: 0;
  margin-top: $height;
  transform: translateX(-15%);
  width: 110px !important;
  //left: 50%;
}

::v-deep .el-button,
::v-deep .el-button--default,
::v-deep .el-popover__reference {
  padding: 0;
  border: none;
  background: transparent;
  color: #FFFFFF;

  span {

    color: #FFFFFF;
  }
}

::v-deep .el-button:hover,
::v-deep .el-button--default:hover,
::v-deep .el-popover__reference:hover {
  padding: 0;
  border: none;
  background: transparent;
  color: #FFFFFF;

  span {

    color: #ff0000;
  }
}

.menuTwo {
  text-align: center;

  .menuTwoTitle {
    padding: 13px;
    box-sizing: border-box;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.menuTwoTitle:hover {
  background-color: #e7e7e7;
}

.topBox1 {
  height: 40.9286rem;
}

.logo {
  height: calc(100% / 80 * 50);
  width: auto;
  cursor: pointer;
}

.leftLogo {
  // padding: 1.5rem 0;
  // box-sizing: border-box;
  height: 100%;

  .logoTitle {
    width: 70px;
  }
}

.menuTitle {
  // margin-left: 1.4286rem;
  cursor: pointer;
  //width: 116px;
  height: $height;
  //margin-right: 10px;
  margin: 0 20px;
  line-height: $height;
  text-align: center;
  // padding: 1.5rem 0;
  box-sizing: border-box;
  width: 110px;
}

.menuTitle:hover {
  background-color: #e7e7e7;
}

.menuTitle:first-child {
  margin-left: 0;
}

.separator {
  margin: 0 1.7857rem;
  width: .1429rem;
  height: 1.3571rem;
  background: #FFFFFF;
}

.mask {
  background-color: #333333;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  padding: 1.2857rem;
  box-sizing: border-box;

  .menuList {
    width: 100%;
    padding: .7143rem 0;
    box-sizing: border-box;
    border-bottom: .9996px solid #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      text-align: right;
      color: #ffffff;
    }
  }
}

/* 大尺寸样式 */
.topTopBox {
  width: 100%;
  padding-top: $height;
  box-sizing: border-box;
  overflow: hidden;
}

.content {
  width: 100%;
  // position: absolute;
  // top: 0;
  // left: 0;
  // z-index: 2;
}

.topFixed {
  width: 100%;
  height: $height;
  // padding: 3.8571rem 4.2857rem 4.2857rem 7.4286rem;
  padding: 0 10vw;
  box-sizing: border-box;
  position: fixed;
  // position: sticky;
  top: 0;
  // left: 0;
  z-index: 11;
  background-color: #f7f7f7;
}

.swiperBox {
  width: 100%;
}

.menuBox {
  display: block;
  text-align: right;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;

  span {
    display: block;
    white-space: nowrap;
    // margin-bottom: 1.4286rem !important;
  }
}

.menu {
  display: none;
}

.titleBox {
  color: #FFFFFF;
  margin-top: 21.4286rem;

  .marginTop5:not(:first-child) {
    margin-top: 15px;
  }

  .title {
    color: #FFFFFF;
    //font-size: 4.2857rem;
  }

  .title1 {
    color: #FFFFFF;
    margin-top: 1.4286rem;
  }

  .title2 {
    color: #FFFFFF;
    margin-top: .4286rem;
  }
}

.aboutBox {
  color: #FFFFFF;
  margin-top: 14.2857rem;
  margin-left: 26.4286rem;

  .title {
    color: #FFFFFF;
    //font-size: 4.2857rem;
  }

  .title1 {
    color: #FFFFFF;
    margin-top: 1.1429rem;
  }
}

.menuPhone {
  display: flex;
  align-items: center;
  //margin-right: 40px;
}

@media screen and (max-width: 1200px) {
  ::v-deep .el-submenu .el-submenu__title {
    height: 2rem;
    line-height: 2rem;
    margin-top: 0.8rem;

    span {
      //font-size: 1.8rem;
    }
  }
  lange {
    margin-top: 0.8rem;
  }
  ::v-deep .el-menu > .marginTop5 > .el-menu-item > span {
    //font-size: 1.8rem;
    margin-top: 0.8rem;
  }

  ::v-deep .el-menu-item {
    height: 1.6rem;
    line-height: 1.6rem;
    margin-top: 0.8rem;

    span {
      //font-size: 1.6rem;
    }
  }
  //::v-deep .el-menu-item>span{
  //    font-size: 1.8rem;
  //}
  .menuPhone {
    //display: flex;
    //align-items: center;
    //margin-right: 400px;
  }
  .logo {
    height: 80%;
    width: auto;
    cursor: pointer;
  }

  .leftLogo {
    padding: 20;
  }

  .topTopBox {
    padding-top: $min-height;
    box-sizing: border-box;
    width: 100%;
  }

  .content {
    width: 100%;
    /* 元素宽度 */
    // height: 247px !important;
    /* 元素高度 */
  }

  .topFixed {
    width: 100%;
    height: $min-height;
    padding: 1.2857rem;
    box-sizing: border-box;
  }

  .swiperBox {
    width: 100%;
  }

  .menuBox {
    display: none;
  }

  .logo {
    // width: 9.1429rem;
    // height: 2.1429rem;
    height: 20px;
  }

  .menu {
    display: block;
    width: 1.4286rem;
    height: 1.4286rem;
  }

  .titleBox {
    color: #FFFFFF;
    margin-top: 2.1429rem;
    height: 80vh;
    overflow-y: auto;

    .title {
      //font-size: 1.1429rem;
    }

    .title1 {
      margin-top: .7143rem;
    }

    .title2 {
      margin-top: .2857rem;
    }
  }

  .aboutBox {
    color: #FFFFFF;
    margin-top: 1.4286rem;
    margin-left: 2.1429rem;

    .title {
      //font-size: 1.1429rem;
    }

    .title1 {
      margin-top: .5714rem;
    }
  }
}

.el-menu-vertical-demo {
  width: 100%;
  border: none;
}


</style>
